//inspired from _benderjs/ckeditor/static/tools.setWithHtml
import _ from 'ckLodash';

var markerIndex, markerFound, text;
var SELECTION_START = '{';
var SELECTION_END = '}';
var SELECTION_EMPTY = '{}';

function replaceTextAndMark(foundText, foundIndex) {
    markerFound = foundText;
    markerIndex = foundIndex;
    return '';
}

function setRangeByMarkers(range, node) {
    if (node.type === CKEDITOR.NODE_TEXT) {
        markerFound = markerIndex = null;

        text = node.getText().replace(SELECTION_EMPTY, replaceTextAndMark);
        if (markerFound === '{}') {
            range.setStart(node, markerIndex);
            range.collapse(1);
        } else {
            text = text.replace(SELECTION_START, replaceTextAndMark);
            if (markerFound === SELECTION_START) {
                range.setStart(node, markerIndex);
            }

            text = text.replace(SELECTION_END, replaceTextAndMark);
            // There must be existing range to set its end.
            if (markerFound === SELECTION_END) {
                range.setEnd(node, markerIndex);
            }
        }

        if (markerFound) {
            node.setText(text);
            // There will be no more ranges.
            return false;
        }
    }
}


function setBoundaryOnElement(element, range, rangeFunc, indexClass, boundaryClass) {
    var classes = element.getAttribute('class').split(' ');
    var foundIndexClass = _.find(classes, function (str) {
        return _.startsWith(str, indexClass);
    });
    var startIndex = parseInt(foundIndexClass.replace(indexClass, ''), 10);
    range[rangeFunc](element, startIndex);
    element.removeClass(boundaryClass);
    element.removeClass(foundIndexClass);
}

function isChildClass(_class) {
    return _.startsWith(_class, 'child');
}

function removeChildClassFromElement(element, childClass) {
    var indexes = childClass.replace('child_', '').split('_');
    var childIndex = parseInt(indexes[0], 10);
    var splitIndex = parseInt(indexes[1], 10);
    element.removeClass(childClass);
    element.getChild(childIndex).split(splitIndex);
}

function splitRequiredTextNodes(editable) {
    var splitRequests = editable.find('.split');
    var i = 0;
    var element;
    while (element = splitRequests.getItem(i++)) {
        var classes = element.getAttribute('class').split(' ');
        _(classes)
            .filter(isChildClass)
            .forEach(_.bind(removeChildClassFromElement, null, element));
        element.removeClass('split');
    }
}

function setWithHtml(editable, html) {
    var range = new CKEDITOR.dom.range(editable);
    editable.setHtml(html);
    splitRequiredTextNodes(editable);
    var isStartSet, isEndSet;

    var startElement = editable.findOne('.startContainer');
    var endElement = editable.findOne('.endContainer');
    if (startElement) {
        setBoundaryOnElement(startElement, range, 'setStart', 'startOffset', 'startContainer');
        isStartSet = true;
    }
    if (endElement) {
        setBoundaryOnElement(endElement, range, 'setEnd', 'endOffset', 'endContainer');
        isEndSet = true;
    }
    if (!isStartSet || !isEndSet) {
        // Let's go for a walk.
        var contentRange = new CKEDITOR.dom.range(editable);
        contentRange.selectNodeContents(editable);
        var domWalker = new CKEDITOR.dom.walker(contentRange);
        domWalker.evaluator = _.partial(setRangeByMarkers, range);
        domWalker.lastForward();
    }

    return range;
}

function hasMarkers(html) {
    var hasStartMarker = html.indexOf('{') !== -1 || html.indexOf('startContainer') !== -1;
    var hasEndMarker = html.indexOf('}') !== -1 || html.indexOf('endContainer') !== -1;
    return hasStartMarker && hasEndMarker;
}

function setDataWithSelection(editor, html) {
    var editable = editor.editable();
    if (!hasMarkers(html)) {
        editable.setHtml(html);
        return;
    }
    var listener = editor.on('selectionChange', function (evt) {
        evt.cancel();
    }, null, null, -1000);

    editable.focus();

    listener.removeListener();

    var range = setWithHtml(editable, html);
    var sel = editor.getSelection();

    sel.selectRanges([range]);
}

export default {
    setData: setDataWithSelection
};
